export default {
  //播放音乐数组
  playList: [
    {
      al: {
        id: 73291466,
        name: "那个女孩的家在陕西的最北边",
        pic: 109951163553615600,
        picUrl: "https://p1.music.126.net/8yVAbyuahn9rvVWWVyrwdA==/109951163553615601.jpg",
        pic_str: "109951163553615601",
      },
      name:'那个女孩的家在陕西的最北边',
      id: 1310471772
    }
  ],
  playIndex: 0,
  playControl:false,
  currentTime:0,
  tag: "流行",
  searchValue: "",
}
